import { get, put, del, post } from 'redux/shelf/api';
import { success } from 'redux/shelf/actions';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';

export const actions = {
  fetchUsers: get`accounts`(),
  create: post`accounts`(),
  fetchUser: get`accounts/:id`(),
  remove: del`accounts/:id`(),
  update: put`accounts/:id`(),
};

export const reducer =createReducer({
  fetchUsers: actions.fetchUsers,
  fetchUser: actions.fetchUser
})
